import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import * as AuthSelectors from '../../store/selectors/auth.selectors';
import { AppState } from '../../store/reducers';

@Injectable({
  providedIn: 'root'
})
export class RiderAuthGuard implements CanActivate {
  constructor(private router: Router, private store: Store<AppState>) {}

  canActivate(): Observable<boolean> {
    return this.store.pipe(
      select(AuthSelectors.getCurrentUser),
      take(1),
      map(user => {
        if (user?.user_roles.includes('rider')) {
          return true;
        } else {
          this.router.navigate(['/']);
          return false;
        }
      })
    );
  }
}
